import { Data_getInstance319j5in8e6yr5 as Data_getInstance } from './adapter/GrantDiscordAccessMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { GrantDiscordAccessMutation_VariablesAdapter_instance37ervv779xwn4 as GrantDiscordAccessMutation_VariablesAdapter_instance } from './adapter/GrantDiscordAccessMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(grantDiscordAccess) {
        this.l6h_1 = grantDiscordAccess;
      }
      toString() {
        return 'Data(grantDiscordAccess=' + this.l6h_1 + ')';
      }
      hashCode() {
        return this.l6h_1 == null ? 0 : getBooleanHashCode(this.l6h_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.l6h_1 == other.l6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.m6h_1 = 'a0a2ff4fbaeeebae9d26579701f15dc651303e3d602f36a89a72adc301d4b383';
        this.n6h_1 = 'grantDiscordAccess';
      }
      h6g() {
        return 'mutation grantDiscordAccess($input: GrantDiscordAccessInput!) { grantDiscordAccess(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var GrantDiscordAccessMutationClass;
function GrantDiscordAccessMutation() {
  if (GrantDiscordAccessMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.o6h_1 = input;
      }
      j6g() {
        return 'a0a2ff4fbaeeebae9d26579701f15dc651303e3d602f36a89a72adc301d4b383';
      }
      operationId() {
        return this.j6g();
      }
      x48() {
        return Companion_instance.h6g();
      }
      k6g() {
        return 'grantDiscordAccess';
      }
      operationName() {
        return this.k6g();
      }
      r47(writer, customScalarAdapters, withDefaultValues) {
        GrantDiscordAccessMutation_VariablesAdapter_instance.p6h(writer, this, customScalarAdapters, withDefaultValues);
      }
      q47() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'GrantDiscordAccessMutation(input=' + this.o6h_1.toString() + ')';
      }
      hashCode() {
        return this.o6h_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantDiscordAccessMutation()))
          return false;
        if (!this.o6h_1.equals(other.o6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantDiscordAccessMutation', VOID, VOID, [Mutation()]);
    GrantDiscordAccessMutationClass = $;
  }
  return GrantDiscordAccessMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data3pzhqfxhg1ap1,
  GrantDiscordAccessMutation as GrantDiscordAccessMutation1e5ff0b653k4l,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessMutation.mjs.map
